import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, Avatar } from "@shared/components";
import { formatCPF } from "@modules/users/utils/formatCPF";

export const useUsersListColumns = (
  agreementMap: Record<number, string>,
  onRefetch: () => void,
  translate: (key: string) => string
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("v1/user_admin.fields.id"),
        width: 80,
      },
      {
        field: "full_name",
        headerName: translate("v1/user_admin.fields.full_name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ row }) => (
          <TableCell.Container align="start">
            <Avatar src={row.image} name={row.full_name} size={32} />
            <span style={{ marginLeft: 8 }}>{row.full_name}</span>
          </TableCell.Container>
        ),
      },
      {
        field: "email",
        headerName: translate("v1/user_admin.fields.email"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => <TableCell.Text value={value} />,
      },
      {
        field: "cpf",
        headerName: translate("v1/user_admin.fields.cpf"),
        minWidth: 150,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text value={formatCPF(value)} textAlign="left" />
        ),
      },
      {
        field: "active_agreement",
        headerName: translate("v1/user_admin.fields.active_agreement"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={agreementMap?.[value]}
          />
        ),
      },
      {
        field: "created_at",
        headerName: translate("v1/user_admin.fields.createdAt"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date value={value} align="center" />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton hideText recordItemId={row.id} />
            <DeleteButton
              hideText
              recordItemId={row.id}
              resource="v1/user_admin"
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [agreementMap, translate, onRefetch]
  );
};
